import apiClient from "../../core/apiClient";
import { Integration, TestConnectionResult } from "../../interfaces/DTO/agent/integration";
import { BaseService } from "../BaseService";

class IntegrationService extends BaseService<Integration> {
  constructor() {
    super("/integrations");
  }

  /**
   * בדיקת חיבוריות אינטגרציה
   * @param integrationId מזהה האינטגרציה
   * @returns תוצאת בדיקת החיבור
   */
  async testIntegration(integrationId: number): Promise<TestConnectionResult> {
    const response = await apiClient.post<TestConnectionResult>(
      `${this.baseUrl}/test/${integrationId}`
    );
    return response.data;
  }

  /**
   * הבאת אינטגרציה לפי טוקן
   * @param integrationToken מזהה האינטגרציה
   * @returns אובייקט של אינטגרציה
   */
  async fetchIntegrationByToken(integrationToken: string): Promise<Integration> {
    if (!integrationToken) {
      return {} as Integration;
    }
    const response = await apiClient.get<Integration>(`${this.baseUrl}/${integrationToken}`);
    return response.data;
  }

  /**
   * מחיקת אינטגרציה (override כדי לתמוך ב-string token)
   * @param integrationToken מזהה האינטגרציה למחיקה
   */
  async deleteIntegration(integrationToken: string): Promise<void> {
    await apiClient.delete(`${this.baseUrl}/${integrationToken}`);
  }
}

// ייצוא המחלקה
export const integrationService = new IntegrationService();
